module.exports = __webpack_public_path__ + "9f1b3f7d596c50ef065ad1726051e467.png";